import React, { useState } from 'react';

import { Link } from 'react-router-dom';

import {

  FaBriefcase,

  FaHome,

  FaHotel,

  FaMapMarkerAlt,

  FaPlus,

} from 'react-icons/fa';

import AddressFormModal from '../Account/Addresses/AddressFormModal';
import { canAddSavedAddress } from '../Account/Addresses/addressManagementUtils';
import { buildAuthRequiredRedirectUrl } from '../Account/profileFormUtils';

import DeliveryDistanceMeta from '../../components/DeliveryDistanceMeta/DeliveryDistanceMeta';
import { storeSelectedAddressId } from '../Cart/cartDistanceUtils';

import { sortAddressesForCheckout } from './checkoutAddressUtils';



const ADDRESS_TYPES = [

  { value: 0, label: 'Home', icon: FaHome },

  { value: 1, label: 'Work', icon: FaBriefcase },

  { value: 2, label: 'Hotel', icon: FaHotel },

  { value: 3, label: 'Other', icon: FaMapMarkerAlt },

];



function addressTypeMeta(type) {

  return ADDRESS_TYPES.find((item) => item.value === Number(type)) || ADDRESS_TYPES[3];

}



function formatAddressLines(address) {

  return [address.address, address.city, address.state, address.postalCode]

    .filter(Boolean)

    .join(', ');

}



/**

 * @param {{

 *   isSignedIn: boolean,

 *   loading: boolean,

 *   addresses: Array<object>,

 *   selectedId: number | null,

 *   onSelect: (id: number) => void,

 *   onAddressSaved: (address: object) => void,

 *   signInRedirectPath?: string,

 * }} props

 */

const CheckoutAddressSection = ({

  isSignedIn,

  loading,

  addresses,

  selectedId,

  onSelect,

  onAddressSaved,

  signInRedirectPath = '/checkout',

}) => {

  const [addressModalOpen, setAddressModalOpen] = useState(false);

  const sorted = sortAddressesForCheckout(addresses);
  const canAddAddress = canAddSavedAddress(addresses.length);



  const handleSelect = (id) => {

    storeSelectedAddressId(id);

    onSelect(id);

  };



  const handleSaved = (address) => {

    setAddressModalOpen(false);

    onAddressSaved(address);

  };



  if (!isSignedIn) {

    return (

      <div className="checkout-address-section">

        <h3 className="checkout-address-section__title">Choose a delivery address</h3>

        <p className="checkout-address-hint">

          <Link to={buildAuthRequiredRedirectUrl(signInRedirectPath)}>Sign in</Link> to use saved delivery

          addresses and accurate delivery charges.

        </p>

      </div>

    );

  }



  return (

    <div className="checkout-address-section">

      <h3 className="checkout-address-section__title">Choose a delivery address</h3>



      <AddressFormModal

        open={addressModalOpen}

        onClose={() => setAddressModalOpen(false)}

        onSaved={handleSaved}

        addressesCount={addresses.length}

        saveLabel="Save address"

      />



      {loading ? (

        <p className="checkout-address-hint">Loading saved addresses…</p>

      ) : (

        <div className="checkout-address-grid">

          {sorted.map((address) => {

            const meta = addressTypeMeta(address.type);

            const Icon = meta.icon;

            const selected = address.id === selectedId;

            const hasCoords =

              Number.isFinite(address.latitude) && Number.isFinite(address.longitude);
            return (

              <article

                key={address.id}

                className={`checkout-address-tile${selected ? ' checkout-address-tile--selected' : ''}${!hasCoords ? ' checkout-address-tile--incomplete' : ''}`}

              >

                <div className="checkout-address-tile__head">

                  <span className="checkout-address-tile__icon">

                    <Icon aria-hidden />

                  </span>

                  <div className="checkout-address-tile__labels">

                    <strong>{address.name || meta.label}</strong>

                    {address.isPrimary ? (

                      <span className="checkout-address-tile__badge">Default</span>

                    ) : null}

                  </div>

                </div>

                <p className="checkout-address-tile__lines">{formatAddressLines(address)}</p>
                {hasCoords ? <DeliveryDistanceMeta address={address} /> : null}

                {!hasCoords ? (

                  <small className="checkout-address-tile__warn">

                    Missing map location — edit in My Addresses

                  </small>

                ) : null}

                <button

                  type="button"

                  className={`checkout-address-tile__cta${selected ? ' checkout-address-tile__cta--selected' : ''}`}

                  onClick={() => handleSelect(address.id)}

                  disabled={!hasCoords}

                >

                  {selected ? 'Delivering here' : 'Deliver here'}

                </button>

              </article>

            );

          })}



          {canAddAddress ? (
            <button
              type="button"
              className="checkout-address-tile checkout-address-tile--add"
              onClick={() => setAddressModalOpen(true)}
            >
              <FaPlus aria-hidden />
              <span>Add new address</span>
            </button>
          ) : null}

        </div>

      )}



      {!loading && sorted.length === 0 ? (

        <p className="checkout-address-hint">

          No saved addresses yet. Add one to calculate delivery and tax.

        </p>

      ) : null}

    </div>

  );

};



export default CheckoutAddressSection;

